export default __webpack_public_path__ + "static/media/reptile_or_amphibian.3d07a86b.svg";